import { arrayToObject } from "utils/object-util";
import { useGetStatusesForClientQuery } from "./vehicleStatusSlice";
import { Tooltip, Typography } from "@material-ui/core";
import CustomInput from "components/CustomInput";
import { useSelector } from "react-redux";
import { selectIsClient } from "features/user/userSlice";
import DropdownFilter from "components/DropdownFilter";
import { orderBy } from "lodash";
import { vehicleStatusIds } from "../consts"


export default function VehicleStatusView({ clientId, value, onChange, readonly = true, label = "Status", disabled = false, excludeCheckInOutStatuses = false, required = false }) {

    let { data: clientVehicleStatuses, error: clientVehicleStatusesError, loading: clientVehicleStatusesLoading } = useGetStatusesForClientQuery({ clientId: clientId ?? 0 })
    clientVehicleStatuses = clientVehicleStatuses || [];

    const excludedIds = [vehicleStatusIds.CHECK_IN, vehicleStatusIds.CHECK_OUT];

    const filteredStatuses = excludeCheckInOutStatuses
        ? clientVehicleStatuses.filter(s =>
            !excludedIds.includes(s.id) || s.id === value
        )
        : clientVehicleStatuses;

    let isClient = useSelector(selectIsClient);

    const clientVehicleStatusesLookup = arrayToObject(clientVehicleStatuses);

    // let statusObj = clientVehicleStatuses.find(s => s.id === value && s.aliasClientId == clientId);
    // if (!statusObj) statusObj = clientVehicleStatuses.find(s => s.id === value && !s.aliasClientId);
    const statusObj = clientVehicleStatusesLookup?.[value];
    const renderOption = (value) => {
        return <>
            {value?.alias ? <>
                {isClient ? <span>{value?.alias}</span> : <Tooltip title={value?.alias}>
                    <span>{value?.label}</span>
                </Tooltip>}
            </>
                : <>{value?.label}</>
            }
        </>
    }

    return (
        <>
            {readonly ?
                <>
                    {renderOption(statusObj)}
                </> :
                <CustomInput
                    id="status"
                    label={label}
                    value={value}
                    elementType="dropdown"
                    onChange={val => onChange(+val)}
                    values={orderBy(filteredStatuses, 'name')}
                    showEmpty
                    renderOption={renderOption}
                    disabled={disabled}
                    required
                />
                // <DropdownFilter
                //     withTypeAhead
                //     label={label}
                //     value={value}
                //     elementType="dropdown"
                //     onSelect={val => {
                //         onChange(+val?.id)
                //     }}
                //     values={orderBy(clientVehicleStatuses, 'name')}
                //     showEmpty
                //     renderOption={renderOption}
                //     disabled={disabled}
                // />
            }
        </>
    );
}
